function asNatural(value, label) {
    if (!Number.isInteger(value) || value < 0) {
        throw new Error(`${label} must be a non-negative integer, got ${value}`);
    }
    return value;
}
export function BooleanIdentity(inputs) {
    return {
        Out: inputs.In,
    };
}
export function LogicalAnd(inputs) {
    return { Result: inputs.OperandOne && inputs.OperandTwo };
}
export function LogicalNAnd(inputs) {
    return { Result: !(inputs.OperandOne && inputs.OperandTwo) };
}
export function LogicalOr(inputs) {
    return { Result: inputs.OperandOne || inputs.OperandTwo };
}
export function LogicalNOr(inputs) {
    return { Result: !(inputs.OperandOne || inputs.OperandTwo) };
}
export function LogicalXOr(inputs) {
    return { Result: inputs.OperandOne !== inputs.OperandTwo };
}
export function LogicalXNor(inputs) {
    return { Result: inputs.OperandOne === inputs.OperandTwo };
}
export function LogicalNot(inputs) {
    return { Result: !inputs.Operand };
}
export function NaturalIdentity(inputs) {
    return {
        Out: inputs.In,
    };
}
export function NaturalLessThan(inputs) {
    return {
        LessThanDecision: inputs.LessThanSource < inputs.LessThanTarget,
    };
}
export function NaturalAdd(inputs) {
    return {
        Sum: asNatural(inputs.AddendOne + inputs.AddendTwo, 'Sum'),
    };
}
export function NaturalSubtract(inputs) {
    return {
        Difference: asNatural(inputs.Minuend - inputs.Subtrahend, 'Difference'),
    };
}
export function NaturalMultiply(inputs) {
    return {
        Product: asNatural(inputs.Multiplicand * inputs.Multiplier, 'Product'),
    };
}
export function NaturalDivide(inputs) {
    if (inputs.Divisor === 0) {
        throw new Error('Divisor must be non-zero');
    }
    return {
        Remainder: asNatural(inputs.Dividend % inputs.Divisor, 'Remainder'),
        Quotient: asNatural(Math.floor(inputs.Dividend / inputs.Divisor), 'Quotient'),
    };
}
export function NaturalDouble(inputs) {
    return NaturalMultiply(inputs);
}
